// import logo from "./logo.svg";
import "./App.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import About from "./components/About";
import React, { useState } from "react";
import Alert from "./components/Alert";
import TextUtils from "./components/TextUtils";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {
  const [mode, setMode] = useState("primary"); // Wheather dark mode is enabled or not
  const [navBtnName, setNavBtnName] = useState("Enable Dark Mode");
  const [alert, setAlert] = useState(null);
  const [btnColor, setBtnColor] = useState("black-button");
  // const [yellowBG, setYellowBG] = useState(false);
  // const [greenBG, setGreenBG] = useState(false);
  // const [redBG, setRedBG] = useState(false);
  // const [previousColor, setPreviousColor] = useState("");

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  const toggleMode = () => {
    if (mode === "primary") {
      setMode("dark");
      setNavBtnName("Enable Light Mode");
      document.body.style.backgroundColor = "#484747";
      // document.body.style.backgroundColor = '#3d3838';
      // document.body.style.backgroundColor = '#333131';
      document.body.style.color = "white";
      showAlert("Dark Mode has been enabled!", "success");
      setBtnColor("blue-button");
      // document.title = 'TextUtils - Dark Mode';
    } else {
      setMode("primary");
      setNavBtnName("Enable Dark Mode");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
      showAlert("Light Mode has been enabled!", "success");
      setBtnColor("black-button");
      // document.title = 'TextUtils - Light Mode';
    }
  };
  // const toggleOnClickYellowImg = () => {
  //   setYellowBG(!yellowBG);
  //   if (yellowBG) {
  //     document.body.style.backgroundColor = previousColor;
  //     if (navBtnName === "Enable Light Mode") {
  //       document.body.style.color = "white";
  //       showAlert("Yellow (Dark Mode) has been disabled!", "success");
  //     } else {
  //       document.body.style.color = "black";
  //       showAlert("Yellow (Light Mode) has been disabled!", "success");
  //     }
  //   } else {
  //     setPreviousColor(document.body.style.backgroundColor);
  //     document.body.style.backgroundColor = "yellow";
  //     document.body.style.color = "black";
  //     if (navBtnName === 'Enable Dark Mode') {
  //       showAlert("Yellow (Light Mode) has been enabled!", "success");
  //     }
  //     else {
  //       showAlert("Yellow (Dark Mode) has been enabled!", "success");
  //     }
  //   }
  // };
  // const toggleOnClickGreenImg = () => {
  //   setGreenBG(!greenBG);
  //   if (greenBG) {
  //     document.body.style.backgroundColor = previousColor;
  //     if (navBtnName === "Enable Light Mode") {
  //       document.body.style.color = "white";
  //       showAlert("Green (Dark Mode) has been disabled!", "success");
  //     } else {
  //       document.body.style.color = "black";
  //       showAlert("Green (Light Mode) has been disabled!", "success");
  //     }
  //   } else {
  //     setPreviousColor(document.body.style.backgroundColor);
  //     document.body.style.backgroundColor = "green";
  //     document.body.style.color = "black";
  //     if (navBtnName === 'Enable Dark Mode') {
  //       showAlert("Green (Light Mode) has been enabled!", "success");
  //     }
  //     else {
  //       showAlert("Green (Dark Mode) has been enabled!", "success");
  //     }
  //   }
  // };
  // const toggleOnClickRedImg = () => {
  //   setRedBG(!redBG);
  //   if (redBG) {
  //     document.body.style.backgroundColor = previousColor;
  //     if (navBtnName === "Enable Light Mode") {
  //       document.body.style.color = "white";
  //       showAlert("Red (Dark Mode) has been disabled!", "success");
  //     } else {
  //       document.body.style.color = "black";
  //       showAlert("Red (Light Mode) has been disabled!", "success");
  //     }
  //   } else {
  //     setPreviousColor(document.body.style.backgroundColor);
  //     document.body.style.backgroundColor = "red";
  //     document.body.style.color = "black";
  //     if (navBtnName === 'Enable Dark Mode') {
  //       showAlert("Red (Light Mode) has been enabled!", "success");
  //     }
  //     else {
  //       showAlert("Red (Dark Mode) has been enabled!", "success");
  //     }
  //   }
  // };
  return (
    <>
      <Router>
      <Navbar
        title="TextUtils"
        aboutText="About TextUtils"
        mode={mode}
        toggleMode={toggleMode}
        navBtnName={navBtnName}
        // toggleOnClickYellowImg={toggleOnClickYellowImg}
        // toggleOnClickGreenImg={toggleOnClickGreenImg}
        // toggleOnClickRedImg={toggleOnClickRedImg}
      />
      <Alert alert={alert} />
      {/* <Navbar title = "PranavArya37" aboutText = "About PranavArya"/> */}
      <div className="container my-3">
        <Routes>
        <Route path="/" element={<TextForm
                showAlert={showAlert}
                heading="Enter The Text To Analyze Below"
                mode={mode}
                btnColor={btnColor}
                />}></Route>
        <Route path="/home" element={<TextForm
                showAlert={showAlert}
                heading="Enter The Text To Analyze Below"
                mode={mode}
                btnColor={btnColor}
                />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/textutils" element={<TextUtils/>}></Route>
        </Routes>
      </div>
      </Router>
    </>
  );
}

export default App;


